import { GetEmployeeDetailsResponseJSON } from "@performyard/service-contracts";

import { PYUseQueryOptions } from "../../../api/hooks/StandardQueryArguments";

import { getEmployeeCustomFields } from "../../../api/services/defs/internal-api";

export const employeeCustomFieldsQuery = (
	employeeId: string,
	options?: PYUseQueryOptions<GetEmployeeDetailsResponseJSON>
) => ({
	queryKey: ["employeeCustomFields", employeeId],
	queryFn: async () => await getEmployeeCustomFields(employeeId),
	meta: {
		errorMessage: "There was a problem fetching the employee custom fields",
	},
	...options,
});
